var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgMask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 375 446",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.944 216.746c91.271-25.652 100.58-43.058 190.257-54.723s205.95 23.241 247.616 76.152c41.667 52.911 21.026 179.431-102.105 224.458-123.13 45.028-425.348 43.784-560.183-47.308-134.836-91.093-136.521-148.419-30.599-161.378 105.923-12.958 163.742-11.549 255.013-37.201z",
    fill: "#1A2026"
  })));
}
export default SvgImgMask;